import React from 'react';
import './GroundStateBadge.css';

/**
 * Counts of aircraft by ground state, on the map like the Arrivals stats overlay
 * (.prediction-stats-overlay). The dot under each label is the state's GroundStateBadge colour, so
 * a counter and the table pills match; every counter is labelled, so Mono loses nothing.
 */
export default function GroundCounters({ items, extra }) {
  return (
    <div className="prediction-stats-overlay ground-counters">
      {items.map(it => (
        <div className="stat-item" key={it.label}>
          <div className="stat-value">{it.value}</div>
          <div className="stat-label">
            <span className={`ground-counter-dot ground-state-${it.cls}`} aria-hidden="true" />
            {it.label}
          </div>
        </div>
      ))}
      {extra}
    </div>
  );
}
